export const fileTypes = Object.freeze({
  download: {
    PDF: 'application/pdf',
    BOL: 'BOL',
    MPL: 'MPL',
  },
})
